enum NodeEnv {
  Development = 'development',
  Production = 'production',
  Test = 'test'
}

class EnvironmentService {
  private constructor() {}

  static get PUBLIC_URL(): string {
    return process.env.PUBLIC_URL;
  }

  static get BRANCH(): string {
    return process.env.BRANCH;
  }

  static get VERSION(): string {
    return process.env.VERSION;
  }

  public static isNodeEnvDev = () => process.env.NODE_ENV === NodeEnv.Development;

  public static isNodeEnvProd = () => process.env.NODE_ENV === NodeEnv.Production;

  public static isNodeEnvTest = () => process.env.NODE_ENV === NodeEnv.Test;
}

export default EnvironmentService;
